import React from 'react';
import { Clock, Home } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const ComingSoon = ({ title = 'Coming Soon', description = "We're working on something great. Check back soon!", path }) => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title={title}
        description={description}
        path={path}
        noindex
      />
      <Navigation />

      <section className="pt-32 pb-20 bg-gradient-to-br from-[#00594C] to-[#003d35] min-h-[60vh] flex items-center">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-xl mx-auto">
            <div className="w-20 h-20 bg-[#99DF63]/20 rounded-full flex items-center justify-center mx-auto mb-8">
              <Clock className="w-10 h-10 text-[#99DF63]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {title}
            </h1>
            <p className="text-lg text-gray-200 mb-10">
              {description}
            </p>
            <a
              href="/"
              className="inline-flex items-center justify-center space-x-2 bg-[#99DF63] text-[#00594C] px-8 py-4 rounded-full font-bold text-lg hover:bg-[#8BCF52] transition-all shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
            >
              <Home className="w-5 h-5" />
              <span>Go Home</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ComingSoon;
